// extracted by mini-css-extract-plugin
module.exports = {"dp3":"DP3_dp3__IzFBi"};